<template>
    <div>
        <el-dialog :close-on-click-modal="false" :visible.sync="showDialog" v-if="showDialog" :modal="false"
            class="myPicShowDialogClass" :destroy-on-close="true" fullscreen :show-close="showClose" append-to-body>
            <div>
                <el-container style="overflow-x: hidden">
                    <el-aside width="224px" style="
                        background-color: #304156;
                        margin-bottom: 0px;
                        margin-left: 0px;
                        margin-top: 0px;
                        overflow-x: hidden;
                        overflow-y: hidden;
                      ">
                        <el-menu :default-active="active" :default-openeds="activeNames" class="el-menu-vertical-demo"
                            @select="changeView" background-color="#304156" text-color="#bfcbd9"
                            active-text-color="#409EFF"
                            style="overflow-x: hidden;position: absolute;left: 0px;width: 224px">
                            <!-- <el-submenu index="1">
                                <template slot="title">
                                    <i class="el-icon-location"></i>
                                    <span>档案首页</span>
                                </template>
                            </el-submenu> -->
                            <el-menu-item index="1">
                                <i class="el-icon-location"></i>
                                <span slot="title">档案首页</span>
                            </el-menu-item>
                            <el-submenu index="2">
                                <template slot="title">
                                    <i class="el-icon-location"></i>
                                    <span>健康档案</span>
                                </template>
                                <el-menu-item index="2-1">基础信息</el-menu-item>
                                <el-menu-item index="2-2">既往病史</el-menu-item>
                                <el-menu-item index="2-3">家庭成员</el-menu-item>
                            </el-submenu>
                            <el-submenu index="3">
                                <template slot="title">
                                    <i class="el-icon-location"></i>
                                    <span>慢病专项</span>
                                </template>
                                <el-menu-item index="3-1">诊断信息</el-menu-item>
                                <el-menu-item index="3-2">检验检查</el-menu-item>
                                <el-menu-item index="3-3">服药管理</el-menu-item>
                                <el-menu-item index="3-4">检测记录</el-menu-item>
                                <el-menu-item index="3-5">随访管理</el-menu-item>
                                <el-menu-item index="3-6">协诊管理</el-menu-item>
                                <el-menu-item index="3-7">健康体检</el-menu-item>
                                <!-- <el-menu-item index="3-8">年度评估</el-menu-item> -->
                            </el-submenu>
                            <!-- <el-submenu index="3">
                                <template slot="title">
                                    <i class="el-icon-location"></i>
                                    <span>一体化</span>
                                </template>
                                <el-menu-item index="3-1">一体化管理</el-menu-item>
                            </el-submenu> -->

                        </el-menu>
                    </el-aside>

                    <el-container>
                        <el-header>
                            <el-row>
                                <div style="margin-top: 12px">
                                    <el-button style="float: right; margin-right: 0px" type="primary" size="mini"
                                        icon="el-icon-arrow-left" @click="setDialogClosed">返回患者列表</el-button>
                                </div>
                            </el-row>
                        </el-header>

                        <el-main>
                            <div style="margin-left: 50px;">
                                <component :is="currentView" :pInfo="pInfo" v-if="update"></component>
                            </div>
                        </el-main>
                    </el-container>
                </el-container>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getLatestRiskFactors } from "@/api/health/RiskQuery";
import baseInfo from "./info/healthInfo/baseInfo.vue";
import diseaseHistoryInfo from "./info/healthInfo/diseaseHistoryInfo.vue";
import familyMemberInfo from "./info/healthInfo/familyMemberInfo.vue";
import diagnosticInfo from "./info/diseaseInfo/diagnosticInfo.vue";
import labAndExamInfo from "./info/diseaseInfo/labAndExamInfo.vue";
import medicineManagement from "./info/diseaseInfo/medicineManagement.vue";
import inspectionRecord from "./info/diseaseInfo/inspectionRecord.vue";
import followUpManagement from "./info/diseaseInfo/followUpManagement.vue";
import cooperativeDiagnosis from "./info/diseaseInfo/cooperativeDiagnosis.vue";
import physicalExamination from "./info/diseaseInfo/physicalExamination.vue";
import annualEvaluation from "./info/diseaseInfo/annualEvaluation.vue";
import integratedManagement from "./info/integrated/integratedManagement.vue";


export default {
    components: {
        baseInfo,
        diseaseHistoryInfo,
        familyMemberInfo,
        diagnosticInfo,
        labAndExamInfo,
        medicineManagement,
        inspectionRecord,
        followUpManagement,
        cooperativeDiagnosis,
        physicalExamination,
        annualEvaluation,
        integratedManagement
    },
    data() {
        return {
            title: "",
            showDialog: false,
            showClose: false,
            relationDetailData: null,
            activeNames: ["2", "3"],
            active: "1",
            factorsQuery: {
                patientId: null,
                dims: null,
            },
            currentView: "integratedManagement",
            pInfo: null,
            height: "",
            weight: "",
            BMI: "",
            waist: "",
            bmiDescStr: "",
            waistDescStr: "",
            update: true
        };
    },
    methods: {
        // 编辑初始化页面内容
        async init(patient) {
            this.showDialog = true;
            this.pInfo = patient;
            console.warn("初始化值", this.pInfo);
            // this.$nextTick(() => {
            //     this.getFactors();
            // });
        },
        getFactors() {
            if (this.pInfo == null) {
                return;
            }

            this.factorsQuery.patientId = this.pInfo.patientId;
            this.factorsQuery.dims = ["height", "weight", "waist", "BMI"];
            getLatestRiskFactors(this.factorsQuery).then((response) => {
                var heightItemArr = response.filter((item) => {
                    return item.paramAlias == "height";
                });
                heightItemArr.sort(function (a, b) {
                    return b.createTime < a.createTime ? -1 : 1;
                });

                var weightItemArr = response.filter((item) => {
                    return item.paramAlias == "weight";
                });
                weightItemArr.sort(function (a, b) {
                    return b.createTime < a.createTime ? -1 : 1;
                });

                var waistItemArr = response.filter((item) => {
                    return item.paramAlias == "waist";
                });
                waistItemArr.sort(function (a, b) {
                    return b.createTime < a.createTime ? -1 : 1;
                });

                var bmiItemArr = response.filter((item) => {
                    return item.paramAlias == "BMI";
                });
                bmiItemArr.sort(function (a, b) {
                    return b.createTime < a.createTime ? -1 : 1;
                });

                if (heightItemArr.length > 0) {
                    var item = heightItemArr[0];
                    this.height = item.paramValue + (item.paramUnit ? item.paramUnit : '');
                }

                if (weightItemArr.length > 0) {
                    var item = weightItemArr[0];
                    this.weight = item.paramValue + (item.paramUnit ? item.paramUnit : '');
                }

                if (waistItemArr.length > 0) {
                    var item = waistItemArr[0];
                    this.waist = item.paramValue + (item.paramUnit ? item.paramUnit : '');
                    // this.waistDescStr = this.waistDesc(item.paramValue);
                }

                if (bmiItemArr.length > 0) {
                    var item = bmiItemArr[0];
                    this.BMI = Number(item.paramValue).toFixed(2);
                    this.bmiDescStr = this.bmiDesc(item.paramValue);
                }
            });
        },
        setDialogClosed() {
            this.currentView = "integratedManagement";
            this.showDialog = false;
        },

        changeView(view) {
            this.update = false;

            if (view == "1") {
                //档案首页
                this.currentView = "integratedManagement";
                this.$nextTick(() => {
                    this.update = true;
                });
            } else if (view == "2-1") {
                //基础信息
                this.currentView = "baseInfo";
                this.$nextTick(() => {
                    this.update = true;
                });
            } else if (view == "2-2") {
                //既往病史
                this.currentView = "diseaseHistoryInfo";
                this.$nextTick(() => {
                    this.update = true;
                });
            } else if (view == "2-3") {
                //家庭成员
                this.currentView = "familyMemberInfo";
                this.$nextTick(() => {
                    this.update = true;
                });
            } else if (view == "3-1") {
                //诊断信息
                this.currentView = "diagnosticInfo";
                this.$nextTick(() => {
                    this.update = true;
                });
            } else if (view == "3-2") {
                //检验检查
                this.currentView = "labAndExamInfo";
                this.$nextTick(() => {
                    this.update = true;
                });
            } else if (view == "3-3") {
                //服药管理
                this.currentView = "medicineManagement";
                this.$nextTick(() => {
                    this.update = true;
                });
            } else if (view == "3-4") {
                //检测记录
                this.currentView = "inspectionRecord";
                this.$nextTick(() => {
                    this.update = true;
                });
            } else if (view == "3-5") {
                //随访管理
                this.currentView = "followUpManagement";
                this.$nextTick(() => {
                    this.update = true;
                });
            } else if (view == "3-6") {
                //协诊管理
                this.currentView = "cooperativeDiagnosis";
                this.$nextTick(() => {
                    this.update = true;
                });
            } else if (view == "3-7") {
                //健康体检
                this.currentView = "physicalExamination";
                this.$nextTick(() => {
                    this.update = true;
                });
            } else if (view == "3-8") {
                //年度评估
                this.currentView = "annualEvaluation";
                this.$nextTick(() => {
                    this.update = true;
                });
            }
            // else if (view == "3-1") {
            //     //一体化
            //     this.currentView = "integratedManagement";
            //     this.$nextTick(() => {
            //         this.update = true;
            //     });
            // }
        },
        getAge(birthday) {
            if (birthday == null) return "";

            var birthdays = new Date(birthday.replace(/-/g, "/"));
            let d = new Date();
            let age =
                d.getFullYear() -
                birthdays.getFullYear() -
                (d.getMonth() < birthdays.getMonth() ||
                    (d.getMonth() == birthdays.getMonth() &&
                        d.getDate() < birthdays.getDate())
                    ? 1
                    : 0);
            return age;
        },
        bmiDesc(bmi) {
            //BMI 体重指数，反映人体肥胖程度
            //BMI=体重（kg）/身高的平方（m2）
            //以下情况BMI不适合
            //1. 未满18岁； 2.是运动员； 3.正在做重量训练； 4.怀孕或哺乳中； 5.身体虚弱或久坐不动的老人。
            var desc = "";
            if (bmi < 18.5) desc = "体重过轻";
            else if (bmi >= 18.5 && bmi < 24.0) desc = "体重正常";
            else if (bmi >= 24.0 && bmi < 28.0) desc = "超重";
            else if (bmi >= 28.0) desc = "肥胖";

            return desc;
        },
        waistDesc(waist) {
            //腰围描述： 向心性肥胖（男性腰围≥90 cm，女性腰围≥85 cm）；
            var desc = "";
            if (waist > 90 && isMale) desc = "向心性肥胖";
            else if (waist > 85 && !isMale) desc = "向心性肥胖";

            return desc;
        },
    },
};
</script>

<style lang="scss" scoped>
.addContact {
    position: absolute;
    top: 10px;
    right: 0;
    border: 1px solid gray;
    border-radius: 30px;
    width: 80px;
    display: inline-block;
    cursor: pointer;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    overflow-y: hidden;
}

.myPicShowDialogClass ::v-deep .el-dialog__header {
    padding: 0;
}

.myPicShowDialogClass::v-deep .el-dialog__body {
    padding: 0;
}

.myPicShowDialogClass::v-deep .el-dialog__footer {
    padding-bottom: 0px;
}

.el-aside {
    height: calc(100vh);
    overflow-y: hidden;
}

.el-main {
    padding: 0;
    height: calc(100vh - 330px);
}

::v-deep {
    .el-menu-item {
        padding-left: 50px !important;
    }

    // fileMenu
    .fileMenu .el-menu-item {
        padding-left: 80px !important;
    }

    .el-submenu .el-submenu__title {
        padding-left: 50px !important;
    }
}

// .labelRed {
//     border-radius: 50%;
//     color: white;
//     background: red;
//     padding: 3px;
// }

.labelRed {
    height: 24px;
	width: 24px;
    border-radius: 50%;
    color: white;
    background: red;
    display: inline-block;
}

.labelOrange {
    border-radius: 50%;
    color: white;
    background: orange;
    padding: 3px;
}

.labelGreen {
    border-radius: 50%;
    color: white;
    background: green;
    padding: 3px;
}

.labelGray {
    border-radius: 50%;
    color: white;
    background: gray;
    padding: 3px;
}

.labelNone {
    display: none;
}
</style>